<template lang="pug">
  .grid-item.grid-person-block(
    :class="elClass"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  )
    RouterLink.grid-block.person-block(
      :to="{ name: 'peopleShow', params: { slug: entity.username}}"
      :style="styleObject"
    )
      .pb-content(:class="{ 'slide-out-top': hover}" v-show="!hover")
        .pb-name {{ entity.fullName }}
        .pb-meta
          template(v-if="showLikes")
            icon(data="~@/assets/svg/heart.svg" :fill="false")
          template(v-else)
            icon(data="~@/assets/svg/eye.svg" :fill="false")

          .pb-count {{ countText }}
          .pb-date {{ dateText }} ago

      .pb-details(v-show="hover")
        .pb-name {{ entity.fullName }}
        .pb-bio {{ entity.bio | truncate(100) }}
        .pb-location {{ entity.location }}
        .pb-links(v-if="entity.twitterUrl || entity.website ")
          a(v-if="entity.showTwitterUrl" :href="entity.twitterUrl" title="Twitter Link" target="_blank" rel="nofollow noopener" @click.stop)
            icon(data="~@/assets/svg/twitter.svg" :fill="false" color="#FE8258")
          a(v-if="entity.website" :href="entity.website" title="Website Link" target="_blank" rel="nofollow noopener" @click.stop)
            icon(data="~@/assets/svg/globe.svg" :fill="false" color="#FE8258")

        .pb-block(@click.stop.prevent="block" tabindex="0" v-if="showUserBlock")
          icon(data="~@/assets/svg/x.svg" :fill="false")
</template>

<script>
import { formatDistanceToNowStrict, parseISO } from 'date-fns'

export default {
  props: {
    entity: { type: Object, required: true },
  },

  data() {
    return {
      hover: false,
      imgLoaded: true,
    }
  },

  computed: {
    countText,
    dateText,
    elClass,
    showLikes,
    showUserBlock,
    styleObject,
  },

  mounted() {},

  beforeMount() {
    const img = new Image()
    img.src = this.entity.image
    img.onerror = () => (this.imgLoaded = false)
  },

  watch: {},

  methods: {
    block,
  },

  components: {},
}

/* Computed ---------------------------------------------------- */
function countText() {
  return this.showLikes ? this.entity.likesCount : this.entity.visitCount
}

function dateText() {
  const date = this.showLikes ? this.entity.lastActivity : this.entity.visitedAt
  let formatedDate = formatDistanceToNowStrict(parseISO(date))
  const match = formatedDate.match(/\d+ seconds/)

  if (match) {
    formatedDate = '1 minute'
  }

  return formatedDate
}

function elClass() {
  return {
    'gi-hide': !this.imgLoaded,
  }
}

function showLikes() {
  return this.$route.name == 'peopleIndex'
}

function showUserBlock() {
  return this.$auth.user().id != this.entity.id
}

function styleObject() {
  return {
    '--bg-image-person': `url("${this.entity.image}")`,
  }
}
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
async function block() {
  this.$modal.open('ConfirmBlockUser', { user: this.entity })
}
</script>
